import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { MapPin, ChevronRight } from "lucide-react";
import { GMOAA } from "@/constants/testIds";

export const DistrictCard = ({ district }) => {
  const { tf } = useLang();
  return (
    <Link
      to={`/districts/${district.slug}`}
      data-testid={`${GMOAA.districtCard}-${district.slug}`}
      className="group flex items-center justify-between rounded-xl border border-gmoaa-border-subtle bg-white p-4 transition-all duration-300 hover:-translate-y-0.5 hover:border-gmoaa-green/40 hover:shadow-md"
    >
      <div className="flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-gmoaa-saffron-light text-gmoaa-saffron-hover">
          <MapPin size={18} />
        </span>
        <div>
          <p className="font-medium text-gmoaa-text-dark">{tf(district, "name")}</p>
          <p className="text-xs text-gmoaa-text-muted font-gujarati">{district.name_gu}</p>
          <p className="mt-0.5 text-xs text-gmoaa-green">{district.member_count ?? 0} members</p>
        </div>
      </div>
      <ChevronRight size={18} className="text-gmoaa-text-muted transition-transform group-hover:translate-x-1 group-hover:text-gmoaa-green" />
    </Link>
  );
};
